import React from 'react';
import {
    formatTransactionType,
    formatTransactionAmount,
    formatTransactionAddress,
    formatTransactionDate,
    getTransactionHash,
    getStatusClass
} from '../../../utils/transactionUtils';

const TransactionRow = ({ tx, index, onTransactionClick }) => {
    const type = formatTransactionType(tx);
    const hash = getTransactionHash(tx);

    return (
        <tr
            key={index}
            onClick={() => onTransactionClick && onTransactionClick(tx)}
            className={onTransactionClick ? "cursor-pointer" : ""}
        >
            <td className="">
                <span className={`fw-semibold ${type === "Send" || type === "Unshield" || type === "Unshielded" ? "text-danger" : "text-success"}`}>
                    {type}
                </span>
            </td>
            <td className="">
                <div className="fw-semibold">
                    {formatTransactionAmount(tx)}
                </div>
            </td>
            <td className="">
                <code className="bg-gray-200 px-2 py-1 rounded text-nowrap text-dark">
                    {formatTransactionAddress(tx)}
                </code>
            </td>
            <td className="">
                <small className="text-muted">{formatTransactionDate(tx)}</small>
            </td>
            <td className="">
                <code className="bg-gray-200 px-2 py-1 rounded text-nowrap text-dark">
                    {hash ? `${hash.slice(0, 6)}...${hash.slice(-8)}` : 'N/A'}
                </code>
            </td>
            <td className="">
                <span className={getStatusClass(tx.status)}>
                    {tx.status || 'Unknown'}
                </span>
            </td>
        </tr>
    );
};

export default TransactionRow;
